<template>
  <b-form-group 
    v-if="isAdmin && editable" 
    label="Tags"
    label-for="tags-input"
  >
    <!-- Huidige tags weergeven -->
    <div class="mb-2" v-if="tagsLocal.length > 0">
      <b-badge 
        v-for="tag in tagsLocal" 
        :key="tag" 
        variant="primary" 
        class="mr-1 mb-1"
        style="font-size: 0.9em;">
        {{ tag }}
        <b-icon 
          icon="x" 
          class="ml-1" 
          style="cursor: pointer;" 
          @click="removeTag(tag)" />
      </b-badge>
    </div>

    <!-- Autocomplete input -->
    <b-input-group size="sm">
      <b-form-input
        id="tags-input"
        v-model="searchQuery"
        placeholder="Typ om tags te zoeken..."
        @input="onSearchInput"
        @keydown.enter.prevent="addFirstSuggestion"
        @keydown.down.prevent="highlightNext"
        @keydown.up.prevent="highlightPrev"
        autocomplete="off"
      />
    </b-input-group>

    <!-- Suggesties dropdown -->
    <div 
      v-if="showSuggestions && filteredSuggestions.length > 0" 
      class="suggestions-dropdown border rounded mt-1 bg-white shadow-sm"
      style="max-height: 200px; overflow-y: auto; position: absolute; z-index: 1000; min-width: 250px;">
      <div
        v-for="(suggestion, index) in filteredSuggestions"
        :key="suggestion.value.id"
        :class="['suggestion-item', 'px-3', 'py-2', { 'bg-primary text-white': index === highlightedIndex }]"
        style="cursor: pointer;"
        @click="addTag(suggestion)"
        @mouseenter="highlightedIndex = index">
        {{ suggestion.text }}
        <small class="text-muted" v-if="index !== highlightedIndex"> ({{ suggestion.value.id }})</small>
        <small class="text-white-50" v-else> ({{ suggestion.value.id }})</small>
      </div>
    </div>

    <small class="text-muted d-block mt-1">
      Typ om te zoeken, klik of druk Enter om toe te voegen
    </small>
  </b-form-group>
</template>

<script>
export default {
  name: 'RecipeTags',
  props: {
    selectedTags: {
      type: Array,
      default: () => []
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    availableTags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tagsLocal: [...this.selectedTags],
      searchQuery: '',
      showSuggestions: false,
      highlightedIndex: 0
    };
  },
  computed: {
    filteredSuggestions() {
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        return [];
      }
      const query = this.searchQuery.toLowerCase();
      return this.availableTags.filter(tag => {
        // Zoek in naam en ID
        const matchesName = tag.text && tag.text.toLowerCase().includes(query);
        const matchesId = tag.value && tag.value.id && tag.value.id.toLowerCase().includes(query);
        // Filter al toegevoegde tags
        const notAlreadyAdded = !this.tagsLocal.includes(tag.text);
        return (matchesName || matchesId) && notAlreadyAdded;
      });
    }
  },
  watch: {
    selectedTags(newTags) {
      this.tagsLocal = [...newTags];
    }
  },
  methods: {
    onSearchInput() {
      this.showSuggestions = this.searchQuery.length > 0;
      this.highlightedIndex = 0;
    },
    addTag(suggestion) {
      if (!this.tagsLocal.includes(suggestion.text)) {
        this.tagsLocal.push(suggestion.text);
        this.$emit('update-tags', this.tagsLocal);
      }
      this.searchQuery = '';
      this.showSuggestions = false;
    },
    addFirstSuggestion() {
      if (this.filteredSuggestions.length > 0) {
        this.addTag(this.filteredSuggestions[this.highlightedIndex]);
      }
    },
    removeTag(tag) {
      const index = this.tagsLocal.indexOf(tag);
      if (index > -1) {
        this.tagsLocal.splice(index, 1);
        this.$emit('update-tags', this.tagsLocal);
      }
    },
    highlightNext() {
      if (this.highlightedIndex < this.filteredSuggestions.length - 1) {
        this.highlightedIndex++;
      }
    },
    highlightPrev() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      }
    }
  },
  mounted() {
    // Sluit suggesties bij klik buiten
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showSuggestions = false;
      }
    });
  }
};
</script>

<style scoped>
.suggestion-item:hover {
  background-color: #007bff;
  color: white;
}
.suggestion-item:hover .text-muted {
  color: rgba(255,255,255,0.7) !important;
}
</style>
